<div class="container-fluid" >
    <mat-form-field mrasDateFormat1>
        <input matInput [matDatepicker]="picker" 
            attr.data-test-input-type="inputType" (dateChange)="onDateChange()" (blur)="onDateChange()"
            [min]="minDate" [max]="maxDate" [formControl]="dateValue" appMrasMaskDate [disabled]="summaryMode"
            [readonly]="summaryMode">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker [disabled]="summaryMode"></mat-datepicker>
    </mat-form-field>
    <mat-error *ngIf="question.invalid">required</mat-error>
</div>